import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { Input } from "reactstrap";
import { UserSchedule, UserEventsRequestState } from "../../../store/ScheduleSync/ScheduleSyncUserAction";
import StatusCode from "../../../util/StatusCode";
import ActiveToggle from "../../misc/ActiveToggle";
import TableHorizontal, { InfoObject } from "../../misc/TableHorizontal";
import * as Helper from '../../../util/Helper';
import { useTranslation } from "react-i18next";
import { ScheduleSync_UserScheduleFilter } from "../../../models/CoreScheduleSyncModels";
import { RootState } from "../../../store/store";



const ScheduleSyncUserSchedule = () => {
    const { t } = useTranslation(['scheduleSync']);

    const { userId } = useParams();
    const dispatch = useDispatch();
    const events = useSelector<RootState, UserEventsRequestState>(state => state.schedulesync_users.events);

    const [filter, setFilter] = useState<ScheduleSync_UserScheduleFilter>({
        onlyActive: events.filter?.onlyActive ?? true,
        weekDate: events?.filter?.weekDate !== undefined ? events.filter?.weekDate : new Date()
    });

    useEffect(() => {
        if (userId) {
            UserSchedule(userId, filter)(dispatch);
        }
    }, [dispatch, filter, userId]);

    const updateWeek: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        var value = e.target.value;
        if (!value) {
            value = Helper.getISODate(new Date());
        }
        setFilter({ ...filter, weekDate: new Date(value) });
    }

    const mapSchedule = (): InfoObject[] => {
        if (events.code !== StatusCode.COMPLETE) {
            return [];
        }

        return events.data.map(event => ({
            id: event.eventId,
            data: [
                { value: <Link to={`/schedulesync/event/${event.eventId}/information`}>{event.title}</Link> },
                { value: event.location },
                { value: t(`userSchedule.${event.role}`) },
                { value: Helper.active(event.active) },
                { value: Helper.formatDate(event.startTime) },
                { value: Helper.formatDate(event.endTime) },
            ]
        }))
    }

    const renderSchedule = () => (
        <TableHorizontal
            header={[
                { value: t('commonTableHeaders.title', { ns: 'scheduleSync' }) },
                { value: t('commonTableHeaders.location', { ns: 'scheduleSync' }) },
                { value: t('genericTableHeaders.role', { ns: 'common' }) },
                { value: t('genericTableHeaders.active', { ns: 'common' }) },
                { value: t('commonTableHeaders.startTime', { ns: 'scheduleSync' }) },
                { value: t('commonTableHeaders.endTime', { ns: 'scheduleSync' }) }]}
            info={mapSchedule()}
            error={events.code === StatusCode.ERROR}
            searching={events.code === StatusCode.PENDING}
            noResMsg={t('noResult.userEvents', { ns: 'scheduleSync' })}
        />);

    return (<>
        <div className="header_member_table large filter-under-text">
            <span className="text">{t('user.schedule.title', { ns: 'scheduleSync' })}</span>
            <Input
                type="date"
                name="week"
                className="input_week"
                value={filter.weekDate.toLocaleDateString()}
                onChange={updateWeek}
            />
            <span className="right">
                <ActiveToggle
                    onlyActive={filter.onlyActive ?? true}
                    update={(active) => setFilter({ ...filter, onlyActive: active })}
                    disabled={events.code === StatusCode.PENDING}
                />
            </span>
        </div>
        {renderSchedule()}
    </>)
}

export default ScheduleSyncUserSchedule;
